export default "__VITE_ASSET__BOqiLALa__"